<template>
  <van-popup v-model:show="isShowDialog" teleport="body" @click-overlay="handleClose" :style="vanPopupStyle"
    class="mDialogV2" round>
    <div class="mDialogV2__content">
      <div class="mDialogV2__title">{{ headerText }}</div>
      <div class="mDialogV2__close" :class="{ 'mDialogV2__closeAr': language === 'ar' }" @click="handleClose">
        <img fr src="@/assets/img/close.png" alt="close" />
      </div>
      <div class="mDialogV2__middle">
        <qr-code class="mDialogV2__middle--logo" :value="qrCodeUrl" :width="qrCodeWidth" />
      </div>
      <div class="mDialogV2__footer">
        <van-button class="mDialogV2__footer--button" type="primary" @click="handleClickBtn"
          @touchstart="handleClickBtn">{{ btnText }}
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script lang='ts'>
import { reactive, toRefs, Ref, PropType, watchEffect, computed, ComputedRef } from 'vue'
import { Popup, Button } from 'vant'
import { getRequestLanguage } from '@/api/utils'

interface MDialogState {
  isShowDialog: Ref<boolean>
  vanPopupStyle: Ref<object>
  handleClickBtn: () => void
  handleClose: () => void
  language: Ref<string>
  qrCodeWidth: ComputedRef<number>
}
export default {
  name: 'MDialog',
  components: {
    [Popup.name as string]: Popup,
    [Button.name as string]: Button
  },
  props: {
    show: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    },
    style: {
      type: Object as PropType<object>,
      default: null
    },
    headerText: {
      type: String as PropType<string>,
      default: '手机扫码下载weelife App'
    },
    btnText: {
      type: String as PropType<string>,
      default: '下载App'
    },
    qrCodeUrl: {
      type: String as PropType<string>,
      default: window.location.href
    },
    qrCodeLogo: {
      type: String as PropType<string>,
      default: 'logo.png'
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: true
    },
    onDownload: {
      type: Function as PropType<() => void>,
      required: true
    }
  },
  setup(
    props: Readonly<{
      show: boolean
      style: object
      onClose: () => void
      onDownload: () => void
    }>
  ): MDialogState {
    const state = reactive<{
      isShowDialog: boolean
      vanPopupStyle: object
    }>({
      isShowDialog: props.show,
      vanPopupStyle: props.style
    })

    const qrCodeWidth = computed(() => {
      if (window.innerHeight < 500) {
        return 110
      } else {
        return 200
      }
    })

    watchEffect(() => {
      state.isShowDialog = props.show
    })

    watchEffect(() => {
      state.vanPopupStyle = props.style
    })

    const handleClickBtn = () => {
      props.onDownload()
    }

    const handleClose = () => {
      props.onClose()
    }

    const language = computed(() => {
      return getRequestLanguage()
    })

    return {
      ...toRefs(state),
      handleClickBtn,
      handleClose,
      language,
      qrCodeWidth
    }
  }
}
</script>
<style lang='scss' scoped>
@include b(mDialogV2) {
  padding: 10px;

  @include e(content) {
    width: 630px;
    height: 100%;
    border-radius: 40px;
    position: relative;
  }

  @include e(title) {
    max-width: 70%;
    margin: 10px auto 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    font-size: 32px;
    font-weight: 600;
    line-height: 43px;
    color: #222625;
    text-align: center;
  }

  @include e(middle) {
    text-align: center;
  }

  @include e(footer) {
    width: 100%;
    padding: 10px 0px 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    @include m(button) {
      width: 540px;
      height: 90px;
      border-radius: 50px;
      font-size: 32px;
      font-weight: 600;
      background: $btnBg !important;
      border: var(--van-button-border-width) solid $btnBg !important;
      color: $btnText;
    }
  }

  @include e(close) {
    position: absolute;
    width: 35px;
    height: 35px;
    top: 25px;
    right: 40px;
    z-index: 9999;
  }

  @include e(closeAr) {
    position: absolute;
    width: 35px;
    height: 35px;
    top: 25px;
    right: auto;
    left: 40px;
    z-index: 9999;
  }
}
</style>
